import isWhitelistHost from './isWhitelistHost';
/**
 * Redirects only when passed
 * with a whitelist url host
 * @param url - the url string
 */
const redirectToUrl = (url) => {
    if (isWhitelistHost(url)) {
        window.location.href = url;
    }
};
export default redirectToUrl;
